import { serializePresentation } from "@/utils/agentPresentation";

export const withAgentPresentation = (
  payload,
  {
    presentation,
    originalPresentation = null,
    canManageTeamProfile = false,
    prompt = null,
    presentationRevision = null,
  },
) => {
  const result = {
    ...payload,
    presentation: serializePresentation(presentation, originalPresentation),
  };

  if (canManageTeamProfile) result.prompt = prompt || null;
  if (presentationRevision !== null && presentationRevision !== undefined) {
    result.expected_presentation_revision = presentationRevision;
  }

  return result;
};
